import React, { useState, useEffect } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import PaymentMultiple from "./Components/PaymentMultiple";
import PaymentSingleChart from "./Components/PaymentSingleChart";
import Loader from "./Components/Loader";
const DashboardPage1=()=>{

     useEffect(()=>{
                    document.title="Payment Dashboard | Balaji Badminton Academy"
                  },[]);
    return(
        <>
        <Header/>
        <Loader/>
            <PaymentMultiple/>
            <PaymentSingleChart/>
        <Footer/>
        </>
    );
}

export default DashboardPage1;